
module.directive('americorpsSlotSelect', function($http, ApiUrl, BasicOptions) {
    return {
        restrict: 'E',
        templateUrl: 'students/americorps/slotSelect',
        require: 'ngModel',
        scope: {programId: '='},
        link: function(scope, element, attrs, ngModel) {
            var value;

            scope.data = {};
            scope.slotTypes = BasicOptions.amcHourTypes;

            function findValue(slot) {
                if (slot) {
                    for (i = 0; i < scope.slots.length; i++) {
                        if (slot.year === scope.slots[i].year &&
                                slot.type === scope.slots[i].type) {
                            return scope.slots[i];
                        }
                    }
                }
            }

            var unwatch = scope.$watch('programId', function(id) {
                if (id) {
                    var url = ApiUrl('program', id, 'initiatives', 'slots');
                    $http.get(url).then(function(response) {
                        scope.slots = response.data.slot_types;

                        if (scope.data.value) {
                            scope.data.value = findValue(scope.data.value);
                            scope.change(scope.data.value);
                        }
                    });
                    unwatch();
                }
            });

            ngModel.$render = function() {
                scope.data.value = ngModel.$viewValue;
            };

            scope.change = function(value) {
                ngModel.$setViewValue(value);
                ngModel.$render();
            };

        },
    }
});